import React, { useState } from 'react';
import { db } from '../firebase'; // Firestore instance
import { collection, query, where, getDocs } from 'firebase/firestore'; // Import the Firebase auth instance
import './LoginPage.css';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SyncLoader from "react-spinners/SyncLoader";


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const notify = (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,


        });
    };

    const handleLogin = async (e) => {
        e.preventDefault(); // Prevent form default submission
        console.log("Handle login called");
        try {
            setLoading(true);
            // Reference to the "users" collection
            const usersRef = collection(db, 'users');

            // Query the collection to find matching username
            const q = query(usersRef, where('username', '==', username.trim()));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                notify("User not found");
                setLoading(false);
                return;
            }

            // Check if password matches
            let userFound = false;

            querySnapshot.forEach(async (doc) => {
                const userData = doc.data();

                // if (userData.password === password) {
                //     userFound = true;
                //     console.log('User logged in:', userData);
                //     setLoading(false);
                //     navigate('/home', { state: { user: userData } });
                //     // Redirect user or handle successful login
                // }

                try {
                    const isMatch = await bcrypt.compare(password.trim(), userData.password);
                    if (isMatch) {
                        userFound = true;
                        console.log('User logged in:', userData);
                        setLoading(false);
                        navigate('/home', { state: { user: { ...userData, id: doc.id } } });
                    } else {
                        console.log('Incorrect password');
                    }
                    return isMatch;
                } catch (error) {
                    console.error('Error verifying password:', error);
                }
            });

            if (!userFound) {
                setLoading(false);
                notify('Password does not match');
            }
        } catch (err) {
            setLoading(false);
            console.error('Error fetching user:', err);
            notify('An error occurred. Please try again.');
        }
    };


    const hashPassword = async (password) => {
        // Define the salt rounds (higher means more secure but slower)
        const saltRounds = 10;

        try {
            // Generate a salt and hash the password with it
            const hashedPassword = await bcrypt.hash(password, saltRounds);
            console.log('Hashed Password:', hashedPassword);

            // You can now send this hashed password to your backend
            return hashedPassword;
        } catch (error) {
            notify('An error occurred. Please try again.');
            console.error('Error hashing password:', error);
        }
    };

    const verifyPassword = async (enteredPassword, storedHashedPassword) => {
        try {
            const isMatch = await bcrypt.compare(enteredPassword, storedHashedPassword);
            if (isMatch) {
                console.log('Password is correct');
            } else {
                console.log('Incorrect password');
            }
            return isMatch;
        } catch (error) {
            console.error('Error verifying password:', error);
        }
    };


    return (
        <div className="login-container">
            <div className="login-overlay"></div>

            <div className='login-body-container'>
                {/* <div className='login-body-description-text'>
                    <h1>Admin</h1>
                    <h1>Gate</h1>
                </div> */}
                <div className="login-box">
                    <h2>Sign In</h2>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <form onSubmit={handleLogin}>
                        <input
                            type="username"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        {loading ? <div style={{ margin: '20px' }}><SyncLoader color='rgba(58, 109, 140, 1)' /></div> : <input type="submit" value="Sign in" />}

                    </form>
                </div>
            </div>
            <div className='toast-container'>
                <ToastContainer />
            </div>

        </div>
    );
};

export default Login;
